// extracted by mini-css-extract-plugin
module.exports = {"selected-filter":"SelectedFilter_selected-filter__a4sJ3","remove-button":"SelectedFilter_remove-button__18XZj"};